//import 'bootstrap';
import map from "./maps/maps.js";
import hero from "./hero/hero.js";
import contact from "./contact/contact.js";
import navigation from "./navigation/navigation.js";

hero();
contact();

window.addEventListener('DOMContentLoaded', (event) => {
if(locations)
    map(document.getElementById('map'), locations); 
});	